export enum CaptchaType {
	CAPTCHA = 0,
	BYPASS = 1,
}
